export const enums = {
        address:"https://www.juhaowu.cn",
        // banner 视频
        atoscnMp4:"https://image.juhaowu.cn/cn_video/video/twatos-cn.mp4",
        atoscnMp4480: "https://image.juhaowu.cn/cn_video/video/twatoshi-480p.mp4",
        atoscnMp4720: "https://image.juhaowu.cn/cn_video/video/twatoshi-720p.mp4",
        atoscnMp41080: "https://image.juhaowu.cn/cn_video/video/twatoshi-1080p.mp4",
        // 廖总及项目介绍
        ceoAtoscnMp4: "https://image.juhaowu.cn/cn_video/video/TWATOSHI.mp4",
        ceoAtoscnMp4480: "https://image.juhaowu.cn/cn_video/video/TWATOSHI480p.mp4",
        ceoAtoscnMp4720: "https://image.juhaowu.cn/cn_video/video/TWATOSHI720p.mp4",
        ceoAtoscnMp41080: "https://image.juhaowu.cn/cn_video/video/TWATOSHI1080p.mp4",
        ceoAtoscnVideoImg: "https://image.juhaowu.cn/cn_video/video/TWATOSHICOVER.jpg",
        // 正式 扩大百倍
        downloadUrl:"https://share-plus.juhaowu.net/#/xiazaiye?from=singlemessage",
        // 测试
        // downloadUrl:"http://appone.libangtianbo.net.cn/#/xiazaiye",
        // h5 下载海外版 正式
        seaAtoshiDownloadUrl:"https://h5.atoshi.org/#/download?language=tw",
        // h5 下载海外版 测试
        // seaAtoshiDownloadUrl:"http://aboard-h5-test.juhaowu.cn/#/download",
        // 乐唰下载
        leshuaDownload:"https://leshua.info",
        // 游戏下载
        gamesDownload:"https://game-img.atoshi.mobi/official/box_mobile.jpg",
        judgeIp:"https://shop.atoshi.org/intapi/h5/ipFrom",
    };
    
    


// WEBPACK FOOTER //
// ./src/enum.js